export default {
  "language": "ru",
  "message":
    {
      "title": "Калькулятор жилищных бонусов со смешанным до",
      "zoningDistrict": "Выберите район зонирования",
      "affordabilityLevel": "Выберите уровень доступности",
      "allThatApply": "Выберите все подходящие варианты.",
      "springGardenS": "Расположен ли проект к югу от Спринг-Гарден-стрит",
      "yes": "Да",
      "no": "Нет",
      "affordability": {
        "lowIncome": "Низкий доход",
        "moderateIncome": "Умеренный доход",
      },
      "lotAreaSqft": "Укажите площадь участка в квадратных футах",
      "buildingHeight": "Введите высоту здания",
      "totalUnits": "Предлагаемое количество квартир в проекте:",
      "unitsEarnedLow": "Дополнительные заработанные единицы (низкий доход):",
      "unitsEarnedMod": "Дополнительные заработанные единицы (умеренный доход):",
      "greenRoofBonus": "Количество бонусных единиц «Зеленой крыши»:",
      "modIncomePayment": "Предполагаемый платеж по умеренному доходу:",
      "lowIncomePayment": "Предполагаемый платеж с низким доходом:",
      "requiredAffordableUnits": "Необходимые доступные квартиры MIHB:",
      "requiredMinAffordableUnits": "Требуемое в минуту доступное количество единиц:",
      "totalRequiredAffordabilityUnits": "Общее количество необходимых доступных единиц:",
      "additionalFar": "Дополнительные заработанные FAR:",
      "totalFar": "Всего FAR:",
      "totalFloor": "Общая разрешенная площадь:",
      "overlay": {
        "fithDistrict": "Этот проект находится на территории Пятого окружного округа (/VDO).",
        "greenRoof": "Этот проект получит бонус за зеленую крышу.",
        "minMixed": "Этот проект входит в оверлейю «Районы со смешанным доходом» /MIN..",
        "todDevelopement": "Этот проект входит в программу /TOD, ориентированную на развитие транзитных перевозок.",
      },
      "sFHA": [
        "Особая зона, подверженная наводнениям",
      ],
      "numberOfDwellingUnits": "Количество жилых помещений, разрешенных в рамках базового зонирования:",
      "about": "О нас",
      "aboutTitle": "О жилищной премии со смешанным доходом",
      "aboutSubTitle": "Как использовать калькулятор",
      "paragraphOne": "Бонус за жилье со смешанным доходом предназначен для застройщиков, которые добавляют доступное жилье в свои проекты или вносят взносы в фонд поддержки доступного жилья. В свою очередь, разработка получает больше «по размеру» площади, высоты и/или жилых помещений. Разработчики могут выбрать один из двух бонусных уровней. Умеренный уровень дохода — это меньший бонус, но он предусматривает менее строгие стандарты доступности или меньшую сумму выплат. Низкий уровень дохода — это более крупный бонус, но он предусматривает более строгие стандарты доступности или более высокую сумму выплат.",
      "paragraphTwo": {
        "text": "Калькулятор жилищных бонусов со смешанным доходом используется для точной оценки:",
        "bullets": [
          "Общее количество разрешенных квартир.",
          "Общее количество доступных квартир, которые вам необходимо будет предоставить.",
          "Заменяющая плату сумма, подлежащая уплате за застройку, в которой используется жилищная премия со смешанным доходом.",
        ],
      },
      "paragraphThree": {
        "text": "Для начала выберите район базового зонирования объекта и укажите площадь участка. Вам также следует выбрать все подходящие районы наложения. Вы можете использовать",
        "link": {
          "text": "Атлас",
          "p": {
            "url": "https://atlas.phila.gov/",
          },
        },
        "continuation": "чтобы найти эту информацию.",
      },
      "finalConfirmation": "Этот калькулятор предназначен для концептуального планирования проекта. В случае несоответствия между калькулятором и Кодексом зонирования Филадельфии преимущественную силу имеет Кодекс зонирования Филадельфии. Окончательное подтверждение количества квартир, необходимого количества доступных квартир и/или заменяющей их суммы производится сотрудниками Комиссии по городскому планированию Филадельфии при рассмотрении разрешения на зонирование. ",
      "resources": "Ресурсы",
      "code1": {
        "link": {
          "text": "Филадельфийский кодекс — 14-702 (7) — Жилищная премия со смешанным доходом",
          "p": {
            "url": "https://codelibrary.amlegal.com/codes/philadelphia/latest/philadelphia_pa/0-0-0-293117",
          },
        },
      },
      "code2": {
        "link": {
          "text": "Код Филадельфии — 14-533 — Наземный округ со смешанным доходом",
          "p": {
            "url": "https://codelibrary.amlegal.com/codes/philadelphia/latest/philadelphia_pa/0-0-0-291906",
          },
        },
      },
      "facts": {
        "link": {
          "text": "Информационные бюллетени по жилищным бонусам со смешанным до",
          "p": {
            "url": "https://www.phila.gov/documents/affordable-housing-zoning-bonus-review-application/",
          },
        },
      },
    },
};